import { createAction } from '@reduxjs/toolkit';
import { TwitchToken } from '../../../../Utils/Types';

const authenticate = createAction<TwitchToken>('AUTH_PAGE_AUTHENTICATE');
const getCurrentUser = createAction<TwitchToken>('AUTH_PAGE_GET_CURRENT_USER');

const setIsTesseractLoaded = createAction<boolean>('AUTH_PAGE_SET_IS_TESSERACT_LOADED');

export default {
  authenticate,
  getCurrentUser,
  setIsTesseractLoaded
};
